module.exports = "<app-breadcrumbs></app-breadcrumbs>\r\n"